import { DownOutlined, RightOutlined } from '@ant-design/icons';
import React, { useState } from 'react';

import { Link, useLocation } from 'react-router-dom';

const sidebarMenuItems = [
  {
    label: 'Active Premise/Meter',
    icon: '/assets/Icon-active-premise-meter.svg',
    path: '/active-premise-meter',
  },
  {
    label: 'Alarm/Error Management',
    icon: '/assets/icon-alarm.svg',
    path: '/alarm-error-management',
  },
  {
    label: 'System Analysis',
    icon: '/assets/icon-system-analysis.svg',
    path: '/system-analysis-dashboard',
  },
  {
    label: 'Workforce',
    icon: '/assets/icon-workforce.svg',
    path: '/workforce',
    childs: [
      {
        label: 'Workforce Management',
        icon: '/assets/Icon-awesome-list-ul.svg',
        path: '/wf-dashboard',
      },
      {
        label: 'Technician Management',
        icon: '/assets/Icon-awesome-user-alt.svg',
        path: '/wf-technician-management',
      },
    ],
  },
  {
    label: 'Settings',
    icon: '/assets/icon-role-management.svg',
    path: '/setting',
    childs: [
      {
        label: 'Role Management',
        icon: '/assets/Icon-awesome-list-ul.svg',
        path: '/role-management',
      },
      {
        label: 'Users',
        icon: '/assets/Icon-awesome-user-alt.svg',
        path: '/users',
      },
      {
        label: 'Announcements',
        icon: '/assets/Icon-awesome-user-alt.svg',
        path: '/announcements',
      },
    ],
  },
];

const GenerateSideBarChildrenContent = ({ child, index, isSideBarExpand, pathname }) => {
  return (
    <Link to={child.path} key={index}>
      <li
        key={child.path}
        className={`flex h-[62px] items-center pl-[54px] text-lg font-bold ${
          pathname.indexOf(child.path) === 0 ? 'bg-dark-blue-200' : ''
        }`}
      >
        <div className={`flex items-center gap-5 ${isSideBarExpand ? 'pl-[20px]' : 'pl-[10px]'}`}>
          <div
            className={`h-[20px] w-[20px] ${
              pathname.indexOf(child.path) === 0 ? 'icon-active' : 'text-dark-blue-100'
            } ${child.disable ? 'text-medium-blue-300' : ''}`}
          >
            <img src={child.icon} alt="Icon" />
          </div>
          {isSideBarExpand ? (
            <p
              className={`overflow-hidden whitespace-nowrap ${
                pathname.indexOf(child.path) === 0 ? 'text-light-blue' : 'text-dark-blue-100'
              } ${child.disable ? 'text-medium-blue-300' : ''}`}
            >
              {child.label}
            </p>
          ) : (
            ''
          )}
        </div>
      </li>
    </Link>
  );
};

const SideBar = () => {
  const location = useLocation();
  const [isSideBarExpand, setIsSideBarExpand] = useState(false);
  const settingPaths = ['/setting', '/role-management', '/user'];
  const workforcePaths = ['/workforce', '/dashboard', '/technician-management'];
  const [isSettingSubChild, setIsSettingSubChild] = useState(
    settingPaths.some((path) => location.pathname.indexOf(path) === 0)
  );

  const [isWorkforceSubChild, setIsWorkforceSubChild] = useState(
    workforcePaths.some((path) => location.pathname.indexOf(path) === 0)
  );

  return (
    <div
      className="bg-light-grey-50"
      onMouseEnter={() => {
        setIsSideBarExpand(true);
      }}
      onMouseLeave={() => {
        setIsSideBarExpand(false);
      }}
    >
      <div className={`relative transition-all ${isSideBarExpand ? 'w-[371px]' : 'w-[127px]'}`}>
        <div className={``}>
          {/* <div className={` z-50 ${isSideBarExpand ? " rotate-180" : ""} transition-all absolute -right-4  top-[80px] w-fit bg-light-grey-50 text-dark-blue-200 pl-2 pr-1 py-1 rounded-full cursor-pointer `} onClick={() => setIsSideBarExpand(!isSideBarExpand)}>
                        <CaretRightOutlined className=' text-xl font-extrabold' />
                    </div> */}
          <div className="flex h-[86px] justify-center px-[20px] pt-[9px]">
            <Link to={'/'}>
              <img
                className={`cursor-pointer ${
                  isSideBarExpand ? 'h-[86px] w-[288px]' : 'h-[73px] w-[69px]'
                }`}
                src={` ${
                  isSideBarExpand
                    ? '/assets/latest-logo-update-web-119.png'
                    : '/assets/icon-airselangor.png'
                } `}
                alt="Logo"
              />
            </Link>
          </div>
          <ul
            className="mt-10 w-full overflow-y-auto"
            style={{ height: 'calc(100vh - 130px)' }}
            id="sidebar-menu"
          >
            <Link to={'/'}>
              <li
                className={`flex h-[62px] w-full items-center justify-between pl-[54px] pr-8 text-lg font-bold ${
                  location.pathname === '/' ? 'bg-dark-blue-200' : ''
                }`}
              >
                <div className="flex items-center gap-5">
                  <div
                    className={`h-[20px] w-[20px] ${
                      location.pathname === '/' ? 'icon-active' : 'text-dark-blue-100'
                    } ${false ? 'text-medium-blue-300' : ''}`}
                  >
                    <img src={'/assets/Icon material-dashboard.svg'} alt="Icon" />
                  </div>
                  {isSideBarExpand ? (
                    <p
                      className={`overflow-hidden whitespace-nowrap ${
                        location.pathname === '/' ? 'text-light-blue' : 'text-dark-blue-100'
                      } ${false ? 'text-medium-blue-300' : ''}`}
                    >
                      {'Overall Summary'}
                    </p>
                  ) : (
                    ''
                  )}
                </div>
              </li>
            </Link>
            {sidebarMenuItems.map((item, index) => {
              return (
                <React.Fragment key={index}>
                  {item.disable ? (
                    <li
                      key={item.path}
                      className={`disable flex h-[62px] w-full cursor-not-allowed items-center pl-[54px] text-lg font-bold ${
                        location.pathname.includes(item.path) ? 'bg-dark-blue-200' : ''
                      }`}
                    >
                      <div className="flex items-center gap-5">
                        <div
                          className={`h-[20px] w-[20px] ${
                            item.disable ? 'text-medium-blue-300' : ''
                          }`}
                        >
                          <img src={item.icon} alt="Icon" />
                        </div>
                        {isSideBarExpand ? (
                          <p
                            className={`${
                              location.pathname.includes(item.path)
                                ? 'text-light-blue'
                                : 'text-dark-blue-100'
                            } ${item.disable ? 'text-medium-blue-300' : ''}`}
                          >
                            {item.label}
                          </p>
                        ) : (
                          ''
                        )}
                      </div>
                    </li>
                  ) : (
                    <>
                      <Link
                        key={item.path}
                        to={['/setting', '/workforce'].includes(item.path) ? '#' : item.path} // this prevents the link from navigating if there are children
                        onClick={() => {
                          if (['/setting'].includes(item.path)) {
                            setIsSettingSubChild(!isSettingSubChild);
                          }

                          if (['/workforce'].includes(item.path)) {
                            setIsWorkforceSubChild(!isWorkforceSubChild);
                          }
                        }}
                      >
                        <li
                          key={item.path}
                          className={`flex h-[62px] w-full items-center justify-between pl-[54px] pr-8 text-lg font-bold ${
                            location.pathname.indexOf(item.path) === 0 ? 'bg-dark-blue-200' : ''
                          }`}
                        >
                          <div className="flex items-center gap-5">
                            <div
                              className={`h-[20px] w-[20px] ${
                                location.pathname.indexOf(item.path) === 0
                                  ? 'icon-active'
                                  : 'text-dark-blue-100'
                              } ${item.disable ? 'text-medium-blue-300' : ''}`}
                            >
                              <img src={item.icon} alt="Icon" />
                            </div>
                            {isSideBarExpand ? (
                              <p
                                className={`overflow-hidden whitespace-nowrap ${
                                  location.pathname.indexOf(item.path) === 0
                                    ? 'text-light-blue'
                                    : 'text-dark-blue-100'
                                } ${item.disable ? 'text-medium-blue-300' : ''}`}
                              >
                                {item.label}
                              </p>
                            ) : (
                              ''
                            )}
                          </div>
                          {['/setting'].includes(item.path) &&
                            isSideBarExpand &&
                            (!isSettingSubChild ? <RightOutlined /> : <DownOutlined />)}

                          {['/workforce'].includes(item.path) &&
                            isSideBarExpand &&
                            (!isWorkforceSubChild ? <RightOutlined /> : <DownOutlined />)}
                        </li>
                      </Link>
                      {item?.childs?.length > 0 &&
                        isSettingSubChild &&
                        ['/setting'].includes(item.path) &&
                        item?.childs.map((child, index) => {
                          return (
                            <GenerateSideBarChildrenContent
                              child={child}
                              index={index}
                              pathname={location.pathname}
                              isSideBarExpand={isSideBarExpand}
                            />
                          );
                        })}

                      {item?.childs?.length > 0 &&
                        isWorkforceSubChild &&
                        ['/workforce'].includes(item.path) &&
                        item?.childs.map((child, index) => {
                          return (
                            <GenerateSideBarChildrenContent
                              child={child}
                              index={index}
                              pathname={location.pathname}
                              isSideBarExpand={isSideBarExpand}
                            />
                          );
                        })}
                    </>
                  )}
                </React.Fragment>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SideBar;
